<h1>Attendance Roll </h1>
<form [formGroup]='form' (submit)="onSubmit(form.value)"  >
    <mat-stepper [linear]="true" orientation="horizontal" id="stepper">
    <mat-step [stepControl]="form" errorMessage="Meeting Type is required." label="Details">
    <div class="container-fluid form-margin" *ngIf="!ShowConfirmationPanel">
        <app-meeting class="step-box" [meeting]="form.get('Meeting')" [ID]="id" [meetingID]="meetingId"
            (stepCompleted)="MeetingStepCompleted($event)"></app-meeting>
        <mat-divider class="divider"></mat-divider>
        <app-roster-list class="step-box" [group]="form" [ID]="id" [meetingID]="meetingId" [MeetingRecord]="meetingRecord"
        *ngIf="showRoster"></app-roster-list>
        <div class="container-fluid">
            <div class="button-row">
                <div class="col-lg-1 offset-lg-11 col-6">
                    <div class="button-row mx-0">
                        <button mat-button mat-raised-button color="primary" (click)="confirmUpdates(true)" *ngIf="showRoster"
                            class="button-submit" type="button" matStepperNext>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </mat-step>
    <mat-step [completed]="false" label="Confirmation" >
        <div class="container-fluid form-margin" *ngIf="ShowConfirmationPanel" >
            <app-roster-confirmation [group]="form" [meetingID]="meetingId">

            </app-roster-confirmation>
            <div class="panel panel-info" *ngIf="isProcessing">
                <div class="row">
                    <div class="col-sm-12">
                        Processing
                        <mat-progress-spinner
                            class=""
                            color="Accent"
                            mode="indeterminate"
                            >
                        </mat-progress-spinner>
                    </div>
                </div>
            </div>
            <div class="container-fluid" *ngIf="!isProcessing">
                <div class="button-row row m-0 justify-content-between">
                    <div class="col-lg-3 col-12 p-0">
                        <button mat-button mat-raised-button color="primary" (click)="confirmUpdates(false)"
                            *ngIf="ShowConfirmationPanel" class="button-submit" type="button"  matStepperPrevious>
                            Previous
                        </button>
                    </div>
                    <div class="col-lg-3 col-12 p-0">
                        <button mat-button mat-raised-button color="primary" 
                            *ngIf="ShowConfirmationPanel" class="button-submit" type="submit" matStepperNext >
                            {{ meetingId ? 'Confirm Updated Details' : 'Confirm Attendance' }} 
                        </button>
                    </div>
                    <div class="error-container col-sm-6" *ngIf="errorMsg !== ''">
                        <div class="error-header">
                            <span class="error-title">⚠️ An unexpected error occurred - Please contact your administrator with the information below:</span>
                            <button 
                            type="button"
                            class="copy-btn" 
                            (click)="copyErrorToClipboard()"
                            [class.success]="showCopySuccess">
                            {{ showCopySuccess ? '✓ Copied!' : '📋 Copy Details' }}
                            </button>
                        </div>
                        
                        <div class="error-content">
                            <pre>{{ errorMsg }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-step>
     <mat-step  label="Completed">
          <app-attendance-complete [meetingID]="meetingId" class="container-fluid"></app-attendance-complete>
     </mat-step>
 
    </mat-stepper>
</form>
